import { state } from "./state";
import { byId } from "./dom";
import { renderDetail, renderGrid } from "./render";
import { highlightSelectedCard } from "./grid";

export function selectAsset(prefab: string, id: string): void {
  state.selectedAsset = { prefab, id };
  state.selectedPrefab = null;
  setHash(`/asset/${prefab}/${id}`);
  renderDetail();
  highlightSelectedCard();
}

export function selectPrefab(id: string, version: string | null): void {
  state.selectedPrefab = { id, version };
  state.selectedAsset = null;
  setHash(version ? `/prefab/${id}@${version}` : `/prefab/${id}`);
  renderDetail();
  highlightSelectedCard();
}

export function clearSelection(): void {
  state.selectedAsset = null;
  state.selectedPrefab = null;
  const detail = byId("detail");
  detail.hidden = true;
  detail.innerHTML = "";
  setHash("");
  highlightSelectedCard();
}

export function parseHashAndRender(): void {
  const hash = window.location.hash.replace(/^#/, "");
  if (hash.startsWith("/asset/")) {
    const parts = hash.slice(7).split("/");
    const id = parts.pop();
    const prefab = parts.join("/");
    if (prefab && id) state.selectedAsset = { prefab, id };
  } else if (hash.startsWith("/prefab/")) {
    const rest = hash.slice(8);
    const at = rest.lastIndexOf("@");
    if (at > 0) {
      state.selectedPrefab = { id: rest.slice(0, at), version: rest.slice(at + 1) };
    } else {
      state.selectedPrefab = { id: rest, version: null };
    }
  }
  renderGrid();
  renderDetail();
}

export function setHash(path: string): void {
  if (path) history.replaceState(null, "", `#${path}`);
  else history.replaceState(null, "", " ");
}
